import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MDInput from "components/MDInput";
import * as moment from 'moment';
// import { Radio } from '@mui/material';
import { Checkbox } from '@mui/material';
import * as service from '../../../../services/service';


function AddPurchaseOrder() {
    // const [state, setState] = useState({
    //     quantity: '', rate: '', amount: '', cgst: '', sgst: '', igst: '', totalamount: '',
    //     cgstpercent: '', sgstpercent: '', igstpercent: '', hsncode: ''
    // });
    const [totalAmount, setTotalAmount] = useState('0');
    const [requisitionData, setRequisitionData] = useState([]);
    // const [supplierName, setSupplierName] = useState([]);
    const [supplierId, setSupplierId] = useState('');
    // const [requisitionId, setRequisitionId] = useState('');
    // const [materialId, setMaterialId] = useState('');
    const [terms, setTerms] = useState('');
    const [purchaseOrderDate, setPurchaseOrderDate] = useState(new Date());
    const [isSelected, setIsSelected] = useState([]);
    const [requisitionIds, setRequisitionIds] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const getMaterialRequistionsForPO = () => {
        fetch(
            service.GET_MATERIAL_REQUISITION_FOR_PO,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                if (result[0].message.messageType === 'Failed') {
                    setRequisitionData([]);
                }
                else {
                    setRequisitionData(result);

                    result.forEach((element, index) => {
                        requisitionIds[index] = element.requisitionId;
                        setRequisitionIds([...requisitionIds]);
                        isSelected[index] = false;
                        setIsSelected([...isSelected]);
                    });
                }
            });
    };

    // function calculate(rt, qty, cg, sg, ig, hsn) {
    //     const amt = (parseFloat(rt) * parseFloat(qty)).toFixed(2);

    //     const cgstAmt = ((amt * parseFloat(cg)) / 100) === 0 ? '0' : ((amt * parseFloat(cg)) / 100).toFixed(2);
    //     const sgstAmt = ((amt * parseFloat(sg)) / 100) === 0 ? '0' : ((amt * parseFloat(sg)) / 100).toFixed(2);;
    //     const igstAmt = ((amt * parseFloat(ig)) / 100) === 0 ? '0' : ((amt * parseFloat(ig)) / 100).toFixed(2);;

    //     const total = (parseFloat(amt) + parseFloat(cgstAmt) + parseFloat(sgstAmt) + parseFloat(igstAmt)).toFixed(2);;
    //     setState({
    //         ...state, rate: rt, quantity: qty, cgst: cgstAmt, sgst: sgstAmt, igst: igstAmt, amount: amt, totalamount: total,
    //         cgstpercent: cg === 0 ? '0' : cg, sgstpercent: sg === 0 ? '0' : sg,
    //         igstpercent: ig === 0 ? '0' : ig, hsncode: hsn
    //     });
    // }

    // const getTermsByMaterialCategory = (id) => {
    //     fetch(
    //         service.GET_MATERIAL_CATEGORY_BY_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 MaterialCategoryId: id
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             setTerms(result.terms);
    //         });
    // };

    // const getSupplierByMaterial = (id, qty) => {
    //     fetch(
    //         service.GET_SUPPLIER_FOR_MATERIAL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 MaterialId: id
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             setSupplierId(result.supplierId);
    //             setSupplierName(result.supplierName);
    //             setState({
    //                 ...state, rate: result.rate === 0 ? '0' : result.rate
    //             });
    //             fetch(
    //                 service.GET_HSNCODE_BY_MATERIAL_ID,
    //                 {
    //                     method: 'POST',
    //                     headers: {
    //                         'Accept': 'application/json',
    //                         'Content-Type': 'application/json'
    //                     },
    //                     body: JSON.stringify({
    //                         MaterialId: id
    //                     })
    //                 })
    //                 .then(res => res.json())
    //                 .then(result1 => {
    //                     if (result1.message.messageType === 'Failed') {
    //                         setState({
    //                             ...state, cgstpercent: '0', sgstpercent: '0',
    //                             igstpercent: '0', hsncode: 'Not Available'
    //                         });

    //                         calculate(result.rate, qty, 0, 0, 0, 'Not Available');
    //                     }
    //                     else {
    //                         setState({
    //                             ...state, cgstpercent: result1.cgst === 0 ? '0' : result1.cgst,
    //                             sgstpercent: result1.sgst === 0 ? '0' : result1.sgst,
    //                             igstpercent: result1.igst === 0 ? '0' : result1.igst, hsncode: result1.hsnCode
    //                         });

    //                         calculate(result.rate, qty, result1.cgst, result1.sgst, result1.igst, result1.hsnCode);
    //                     }
    //                 });
    //         });
    // };


    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".requisitionId"] = "Please select requisition";
        }
        if (!purchaseOrderDate) {
            isValid = false;
            errs[".purchaseOrderDate"] = "Please select date";
        }
        if (!totalAmount) {
            isValid = false;
            errs[".totalamount"] = "Please enter total amount";
        }
        setErrors(errs);
        return isValid;
    }
    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        if (validate()) {
            let flag = true;
            setLoading(true);
            // eslint-disable-next-line
            if (window.confirm(`Do you want to save this Purchase Order?`)) {
                fetch(
                    service.ADD_PURCHASE_ORDER,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            PurchaseOrderDate: moment(purchaseOrderDate).format("MM/DD/YYYY"),
                            SupplierId: supplierId,
                            GrandTotalAmount: totalAmount,
                            TermsConditions: terms,
                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                        })
                    })
                    .then(res => res.json())
                    .then(result => {
                        if (result.messageType === 'Success') {
                            requisitionIds.forEach((element, index) => {
                                if (isSelected[index] === true) {
                                    const item = requisitionData.find(obj => obj.requisitionId === element);                                    
                                    fetch(
                                        service.ADD_PURCHASE_ORDER_MR_MAP,
                                        {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({
                                                PurchaseOrderId: result.id,
                                                RequisitionId: element,
                                                MaterialId: item.materialId,
                                                Quantity: item.quantity,
                                                Rate: item.rate,
                                                Amount: item.amount,
                                                CGST: item.cgstAmount,
                                                SGST: item.sgstAmount,
                                                IGST: item.igstAmount,
                                                TotalAmount: item.totalAmount,
                                                CGSTPercent: item.cgstPercent,
                                                SGSTPercent: item.sgstPercent,
                                                IGSTPercent: item.igstPercent,
                                                AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                            })
                                        })
                                        .then(res => res.json())
                                        .then(result1 => {
                                            if (result1.message.messageType === 'Failed') {
                                                // eslint-disable-next-line
                                                alert(result1.message);
                                                flag = false;
                                            }
                                        });
                                }
                            });
                        }
                        else if (result.messageType === 'Failed') {
                            // eslint-disable-next-line
                            alert(result.message);
                        }
                        else {
                            errs[".invalid"] = result.message;
                            setErrors(errs);
                        }
                    });

                if (flag) {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        alert("Data Saved Successfully");
                        setRequisitionIds([]);
                        setIsSelected([]);
                        window.location.reload(false);
                    }, 30000);
                }
                else {
                    // eslint-disable-next-line
                    alert("Error.. Something Went Wrong");
                }
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        const tc = '1. Invoice should bear our reference PO No., PO Date and Item Description as mentioned in the PO.;2. Your invoice must be accompanied with certified delivery challan.; 3. Delivery period – within 10 Days. ;4. Transport Mode – By road.;5. Transporter Name – Arranged by you / to be arranged by ourselves.; 6. Payment Term – 60 / 90 Days.;7. GST will be paid as applicable.;8. Material should be supplied before 04:30 PM only. ;9. Delivery of goods shall be made on the delivery address.';
        setTerms(tc);
        getMaterialRequistionsForPO();
        setLoading(false);
    }, []);

    // const changeHandler = (event) => {
    //     if (event.target.name === 'quantity') {
    //         if (Number.isNaN(parseFloat(event.target.value))) {
    //             // eslint-disable-next-line
    //             alert("Please enter numbers only");
    //             event.target.value = ""; // eslint-disable-line no-param-reassign
    //         }
    //     }
    //     if (event.target.name === 'rate') {
    //         if (Number.isNaN(parseFloat(event.target.value))) {
    //             // eslint-disable-next-line
    //             alert("Please enter numbers only");
    //             event.target.value = ""; // eslint-disable-line no-param-reassign
    //         }
    //     }
    //     setState({ ...state, [event.target.name]: event.target.value });
    // };

    const termChangeHandler = (event) => {
        setTerms(event.target.value);
    }
    // const handleRadioChange = (reqId, matId, qty, catId) => {
    //     setState({ ...state, quantity: qty });
    //     setRequisitionId(reqId);
    //     setMaterialId(matId);
    //     getTermsByMaterialCategory(catId);
    //     getSupplierByMaterial(matId, qty, catId);
    // }

    const handleCheckboxChange = (checked, index, supId, amt) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);

        // alert(supId)
        // alert(supplierId)
        if (!supplierId) {
            setSupplierId(supId);
        }
        else if (supplierId !== supId) {
            // eslint-disable-next-line
            alert("Please select same Supplier");
        }

        if (checked) {            
            let total = 0;
            if (parseFloat(totalAmount) > 0) {
                total = (parseFloat(totalAmount) + parseFloat(amt)).toFixed(2);
            }
            else {
                total = parseFloat(amt).toFixed(2);
            }
            setTotalAmount(total);
        } 
        else{
            const tal = (parseFloat(totalAmount) - parseFloat(amt)).toFixed(2);
            setTotalAmount(tal);
        }       
    }


    const backHandler = () => {
        navigate('/supplier/purchaseorder');
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Purchase Order Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell colSpan="18" align='center' style={{ fontWeight: 'bold' }}>
                                                    Material Requisitions
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>MaterialCode</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition By</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Supplier</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Rate</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>HSNCodes</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>CGSTPercent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>SGSTPercent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>IGSTPercent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>CGSTAmount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>SGSTAmount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>IGSTAmount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>TotalAmount</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {requisitionData.map((row, index) => (
                                                    <TableRow
                                                        key={row.requisitionId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            {/* <Radio onChange={() => handleRadioChange(row.requisitionId, row.materialId, row.quantity, row.materialCategoryId)}
                                                            value={row.requisitionId} name="radio-buttons"
                                                            checked={requisitionId === row.requisitionId} /> */}
                                                            <Checkbox checked={isSelected[index] || false}
                                                                onChange={(e) =>
                                                                    handleCheckboxChange(e.target.checked, index, row.supplierId, row.totalAmount)} id="chkSelect"
                                                            />
                                                        </TableCell>
                                                        <TableCell>{row.requisitionNo}</TableCell>
                                                        <TableCell>{moment(row.requisitionDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{row.material}</TableCell>
                                                        <TableCell>{row.materialCode}</TableCell>
                                                        <TableCell>{row.quantity}</TableCell>
                                                        <TableCell>{row.requisitionByName}</TableCell>
                                                        <TableCell>{row.supplierName}</TableCell>
                                                        <TableCell>{row.rate}</TableCell>
                                                        <TableCell>{row.hsnCodes}</TableCell>
                                                        <TableCell>{row.cgstPercent}</TableCell>
                                                        <TableCell>{row.sgstPercent}</TableCell>
                                                        <TableCell>{row.igstPercent}</TableCell>
                                                        <TableCell>{row.amount}</TableCell>
                                                        <TableCell>{row.cgstAmount}</TableCell>
                                                        <TableCell>{row.sgstAmount}</TableCell>
                                                        <TableCell>{row.igstAmount}</TableCell>
                                                        <TableCell>{row.totalAmount}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".requisitionId"]}</div>
                                    </TableContainer>
                                }
                                <br />
                                <br />
                                <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        {/* <TableRow>
                                            <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                HSN Code : {state.hsncode}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 'bold', fontSize: '14px', width: '30%' }}>
                                                CGST Percent : {state.cgstpercent}
                                            </TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontSize: '14px', width: '30%' }}>
                                                SGST Percent : {state.sgstpercent}
                                            </TableCell>
                                            <TableCell style={{ fontWeight: 'bold', fontSize: '14px', width: '30%' }}>
                                                IGST Percent : {state.igstpercent}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="Supplier" fullWidth value={supplierName || ''}
                                                    name="supplierName"
                                                    onChange={changeHandler}
                                                    id="supplierName"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".supplierId"]}</div>
                                            </TableCell>                                            
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="Quantity" fullWidth value={state.quantity || ''}
                                                    name="quantity"
                                                    onChange={changeHandler}
                                                    id="quantity"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="Rate" fullWidth value={state.rate || ''}
                                                    name="rate"
                                                    onChange={changeHandler}
                                                    id="rate"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".rate"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="Amount" fullWidth value={state.amount || ''}
                                                    name="amount"
                                                    onChange={changeHandler}
                                                    id="amount"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".amount"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="CGST" fullWidth value={state.cgst || ''}
                                                    name="cgst"
                                                    onChange={changeHandler}
                                                    id="cgst"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".cgst"]}</div>
                                            </TableCell>
                                        </TableRow> */}
                                        <TableRow>
                                            {/* <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="SGST" fullWidth value={state.sgst || ''}
                                                    name="sgst"
                                                    onChange={changeHandler}
                                                    id="sgst"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".sgst"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="IGST" fullWidth value={state.igst || ''}
                                                    name="igst"
                                                    onChange={changeHandler}
                                                    id="igst"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".igst"]}</div>
                                            </TableCell> */}
                                            <TableCell style={{ fontSize: '12px' }}>
                                                Purchase Order Date
                                                <DatePicker
                                                    id="purchaseOrderDate"
                                                    selected={purchaseOrderDate}
                                                    onChange={date => setPurchaseOrderDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".purchaseOrderDate"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <MDInput label="Total Amount" fullWidth value={totalAmount || ''}
                                                    name="totalamount"
                                                    // onChange={changeHandler}
                                                    id="totalamount"
                                                    disabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".totalamount"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="2" style={{ fontSize: '12px' }}>
                                                <MDInput label="Terms and Conditions" fullWidth value={terms || ''}
                                                    name="terms"
                                                    onChange={termChangeHandler}
                                                    id="terms"
                                                    multiline
                                                // InputProps={{class: {whiteSpace: ''}}}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".terms"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                BACK
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default AddPurchaseOrder;